const ObjectIcon = ({ fill = "#343741" }) => {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.9856 13.75V11.4357H7.89989V3.72143H5.97132V6.03571H0.957031V0.25H5.97132V2.56429H10.9856V0.25H15.9999V6.03571H10.9856V3.72143H9.05703V10.2786H10.9856V7.96429H15.9999V13.75H10.9856ZM12.1427 4.87857H14.8427V1.40714H12.1427V4.87857ZM12.1427 12.5929H14.8427V9.12143H12.1427V12.5929ZM2.11417 4.87857H4.81417V1.40714H2.11417V4.87857Z"
        fill={fill}
      />
    </svg>
  );
};

export default ObjectIcon;
